module.exports = __webpack_public_path__ + "static/loading4-87c091c1eb5e40d7674fec8c7152d7a4.gif";